import Button from '@/src/common/components/marketing/buttons/Button'

type TGiftBoxButtonProps = {
    isEditing: boolean
    isLoading: boolean
    continueIsLoading: boolean
    setDisplayLiveErrors: Function
    setIsLoading: Function
    setContinueIsLoading: Function
    validateAndAddCart: Function
}

const GiftBoxAddToCartButtons = ({
    isEditing,
    isLoading,
    continueIsLoading,
    setIsLoading,
    setContinueIsLoading,
    setDisplayLiveErrors,
    validateAndAddCart,
}: TGiftBoxButtonProps) => {
    return (
        <>
            <Button
                id={'submit-button'}
                label={!isEditing ? 'Add to cart & checkout' : 'Save changes'}
                showArrow={true}
                onClick={() => {
                    setDisplayLiveErrors(true)
                    setIsLoading(true)
                    validateAndAddCart(false)
                }}
                textTransform={'uppercase'}
                isLoading={isLoading}
                disabled={isLoading || continueIsLoading}
                width={'wide'}
            />
            <Button
                id={'submit-and-continue-button'}
                variant={'primaryOutline'}
                label={
                    !isEditing
                        ? 'Add to cart & keep shopping'
                        : 'Save & keep shopping'
                }
                showArrow={true}
                onClick={() => {
                    setDisplayLiveErrors(true)
                    setContinueIsLoading(true)
                    validateAndAddCart(true)
                }}
                textTransform={'uppercase'}
                isLoading={continueIsLoading}
                disabled={isLoading || continueIsLoading}
                width={'wide'}
                style={{ marginTop: 10 }}
            />
        </>
    )
}

export default GiftBoxAddToCartButtons
